import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';
import SlidingTabs from '../../shared/SlidingTabs';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

const ProfileSlidingTabs = props => {
  const onChange = (e, index) => {
    const changeTab = props.tabs[index];
    const linkPath = LanguageSupportUtil.wrapUrlSafe(changeTab.linkPath, props.context.languageRegionCode);

    if (changeTab.openInNewWindow) {
      window.open(linkPath);
    } else {
      window.location.href = linkPath;
    }
  };

  const activeIndex = props.tabs.findIndex(tab => {
    return tab.isActive;
  });

  return (
    <div className={styles.profileSlidingTabsContainer}>
      <SlidingTabs
        tabs={props.tabs}
        onChange={onChange}
        activeIndex={activeIndex}
        slidingTabsClasses={{ scrollButtons: styles.slidingTabsScrollButtons, root: styles.tabsRoot }}
        tabClasses={{ root: styles.tabRoot }}
      />
    </div>
  );
};

ProfileSlidingTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string,
      isActive: PropTypes.bool,
      openInNewWindow: PropTypes.bool
    })
  )
};

ProfileSlidingTabs.defaultProps = {
  tabs: []
};

export default ProfileSlidingTabs;
